import React from "react";
import { Link } from "react-router-dom";
import ImageGen from "./images/image-gen.png";
import ChatGen from "./images/chat-gen.png";
import RED from "./images/RED2.jpg"

const Welcome = () => {
  return (
    <>
      <div className="welcome-text">
        <p className="first-text">
          Welcome to <span className="shremish-text">Shremish!</span>
        </p>
        <p className="second-text">Your personal thinking assistant.</p>

        <div className="entry-img">
          <Link to="/chatRoulette">
            <div className="entry-img-1">
              <img src={ImageGen} alt=""></img>
              <div className="entry-text">
                <h2>Chat Assistant</h2>
                <p>
                  Chat Assistant is here to provide personalized assistance.
                  Chat Assistant is able to understand your needs and provide
                  accurate responses.
                </p>
              </div>
            </div>
          </Link>

          <Link to="/image-generation">
            <div className="entry-img-1">
              <img src={RED} alt="" style={{ opacity: "0.95" }}></img>
              <div className="entry-text">
                <h2>Image Generation</h2>
                <p>
                  Unleash your creativity with our AI-powered "Image Generation"
                  tool! With just a few clicks, you can generate stunning and
                  unique images for your projects.
                </p>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </>
  );
};

export default Welcome;
